/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: MyLabelPrecompiledTableFactory.ts
 * Project: mle-client-n
 * Committed last: 2022/11/29 @ 1712
 * ---
 * Description:
 */

import {AbstractPrecompiledFactory, PrecompiledBase} from "../abstract/AbstractPrecompiledFactory";
import {ShapeFactory} from "../shape/ShapeFactory";
import Pamela from "@revodigital/pamela";
import {TableBuilder} from "@revodigital/pamela/lib/builders/TableBuilder";
import {ColumnBuilder} from "@revodigital/pamela/lib/builders/ColumnBuilder";
import {HorizontalAlignment} from "@revodigital/pamela/lib/configuration/Alignment";
import {matrixOf} from "@revodigital/pamela/lib/common/Matrix2D";

export interface MyLabelPrecompiledTable extends PrecompiledBase {
    data: string[][];
    columns: number;
}

/**
 * Factory per creare i precompilati MyLabel
 */
export class MyLabelPrecompiledTableFactory extends AbstractPrecompiledFactory<MyLabelPrecompiledTable> {
    private _shapeFactory = new ShapeFactory();

    constructor(index: MyLabelPrecompiledTable[]) {
        super(index);
    }

    produce(data: MyLabelPrecompiledTable): Pamela.Shape | undefined {
        const rows = data.data.length;

        const tBuilder = new TableBuilder({
            width: 500,
            x: 100,
            y: 100,
            height: 300,
            draggable: true,
            stroke: 'black',
            strokeWidth: 2
        });

        const borderPreset = {
            bordered: true,
            borderWidth: 2,
            borderColor: 'black'
        } as Pamela.BorderConfig;

        // Aggiungo la colonna di intestazione
        tBuilder
            .addColumn({
                column: ColumnBuilder
                    .withCells(rows, {
                        bold: true,
                        bottomBorder: borderPreset,
                        rightBorder: borderPreset,
                        topBorder: borderPreset,
                        textAlign: HorizontalAlignment.Left,
                        textColor: 'black',
                        padding: 5,
                        fontSize: 20
                    })
                    .customWidth(60)
                    .setFirst({
                        bold: false
                    })
            })

        for (let i = 1; i < data.columns; i++) {
            // Aggiungo le altre colonne
            tBuilder.addColumn({
                column: ColumnBuilder
                    .withCells(rows, {
                        bottomBorder: borderPreset,
                        rightBorder: borderPreset,
                        topBorder: borderPreset,
                        textAlign: HorizontalAlignment.Right,
                        textColor: 'black',
                        padding: 8,
                        fontSize: 20
                    })
                    .setFirst({bold: true})
                    .autoWidth()
            });
        }

        tBuilder.populateContent(matrixOf(data.data), true);

        return tBuilder.build();
    }
}